var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgramTable',{attrs:{"title":_vm.getCompareListTitle(),"sub-title":_vm.getCompareListSubTitle(),"data":_vm.data,"header":_vm.header},on:{"export":_vm.exportCSV}})}
var staticRenderFns = []

export { render, staticRenderFns }